// Notices the document record leaves in sessionStorage for the Home
// to show on return (see pages/Home, which reads them on mount). They live here,
// outside the pages, so that the Home imports them without loading the record.

// Left by the legacy edit (no longer used: "Modifier le document" stays
// on the record and notifies there). It is kept because the Home still reads it.
export const SESSION_STORAGE_ARCHIVE_EDIT_SUCCESS_KEY = 'ARCHIVE_EDIT_SUCCESS';

// Left by "Supprimer" from the record: the document no longer exists, so the
// record returns to the listing and it is the latter that confirms.
export const SESSION_STORAGE_DOCUMENT_DELETED_KEY = 'ARCHIVE_DELETED';

// Cache key of `GET /archives/document?id=` and of its pages, by id.
export const DOCUMENT_VIEW_KEY = 'DOCUMENT_VIEW';
export const DOCUMENT_PAGES_KEY = 'DOCUMENT_PAGES';
